/**
 * Formats a stored code-style identifier for user-facing display.
 *
 * Division and business-unit names are persisted with underscores as
 * word separators (e.g. `NORTH_AMERICA_BUSINESS_UNIT`,
 * `INDUSTRIAL_SERVICES_DIVISION`). Underscores are word characters,
 * so a long code renders as one unbreakable token that overflows the
 * container / forces horizontal scroll on mobile summary cards and
 * filter chips.
 *
 * This helper is a display-only transform: it replaces every `_` with
 * a single space so the browser can wrap on word boundaries. The
 * underlying string used by filters, query keys, form state, and API
 * inputs must remain the raw underscore form — callers apply this at
 * the render site only.
 *
 * Empty / whitespace-only input returns an empty string so the caller
 * can drive `show`/nullish fallbacks without an extra guard.
 *
 * @example
 *   formatCodeForDisplay('NORTH_AMERICA_BU')   // 'NORTH AMERICA BU'
 *   formatCodeForDisplay('Fulfillment')        // 'Fulfillment'
 *   formatCodeForDisplay('')                   // ''
 *   formatCodeForDisplay(undefined)            // ''
 */
export function formatCodeForDisplay(value: string | null | undefined): string {
  if (!value) return '';
  return value.replace(/_/g, ' ');
}
